// extracted by mini-css-extract-plugin
export default {"success":"G4gGp1iqwku24wBaBQsb","warning":"kGB_t6qDZ_uZzFelVd_x"};